import { goToNextStep, goToErrorPage, setInputError } from './GenericActions';
import ApiService from '../services/ApiService';
import * as types from './ActionTypes';
import { getAllContactData } from './ConfirmActions';
import { recordingProbeStarted } from './probes_action';
import { getContacts } from './ChoiceActions';

const requestUpdateContacts = ({ mail, mobile }) => ({
  type: types.REQUEST_UPDATE_CONTACTS,
  payload: {
    mail,
    mobile,
  },
  requestedAt: Date.now(),
});

const receiveUpdateContactsSuccess = () => ({
  type: types.RECEIVE_UPDATE_CONTACTS_SUCCESS,
  receivedAt: Date.now(),
});

const receiveUpdateContactsFailure = error => ({
  type: types.RECEIVE_UPDATE_CONTACTS_FAILURE,
  error,
  receivedAt: Date.now(),
});

const setContactFields = ({ identities, contacts }) => ({
  type: types.SET_CONTACT_FIELDS,
  payload: {
    identities,
    contacts,
  },
});

/**
 * Update the contact ways of the user
 * Can add a new mobile or mail contact or both
 * @param mail
 * @param mobile
 * @param checked
 * @return {function(*): Promise<T>}
 */
export const updateContacts = ({ mail, mobile, checked }) => (dispatch) => {
  dispatch(recordingProbeStarted());
  dispatch(requestUpdateContacts({ mail, mobile }));
  return ApiService.updateContacts({ mail, mobile, checked }).then(
    (res) => {
      const { step } = res.data;
      dispatch(receiveUpdateContactsSuccess());
      dispatch(goToNextStep(step));
    },
    (err) => {
      dispatch(receiveUpdateContactsFailure(err.response));
      const { response } = err;
      if (response) {
        const { field, code } = response.data;
        switch (code) {
          case 412002:
            dispatch(setInputError({ field, error: 'empty' }));
            break;
          case 412004:
            dispatch(setInputError({ field, error: 'syntaxInvalid' }));
            break;
          case 412005:
            dispatch(setInputError({ field, error: 'mailIsUnknown' }));
            break;
          default:
            dispatch(goToErrorPage());
            break;
        }
      }
    },
  );
};

/**
 * Function to get declared contacts with non obfuscated data and active contact inputs
 * @return {Function}
 */
export const fetchInputsAndDeclaredContacts = () => async (dispatch, getState) => {
  const { identitiesId } = getState().identification;

  await dispatch(getContacts(identitiesId));

  const { contacts, identities } = getState().choice;
  dispatch(setContactFields({ identities, contacts }));

  if (contacts.length > 0) {
    await dispatch(getAllContactData(identitiesId, contacts));
  }
};
